const listeners = {
    /* eslint object-shorthand: 0 */
    clickOnIcon: {
        on() {
            this.input.$icon.on(`click.${ this.instanceId }`, () => {
                const { showed } = this.main;

                if (!showed) {
                    this.dispatch('showCalendar');
                }
                else {
                    this.dispatch('hideCalendar');
                }
            });
        },
        off() {
            this.input.$icon.off(`click.${ this.instanceId }`);
        }
    },
    resizeWindow: {
        on() {
            // Отслеживаем ресайз окна
            let doit;

            $(window).on(`resize.${ this.instanceId }`, () => {
                clearTimeout(doit);

                doit = setTimeout(() => {
                    this.dispatch('resize');
                }, 200);
            });
        },
        off() {
            $(window).off(`resize.${ this.instanceId }`);
        }
    },
    keyupOnInput: {
        on() {
            this.input.$element.on(`keyup.${ this.instanceId }`, (e) => {
                const esc = e.keyCode === 27;
                const enter = e.keyCode === 13;

                if (esc || enter) {
                    this.dispatch('hideCalendar');
                }
            });
        },
        off() {
            this.input.$element.off(`keyup.${ this.instanceId }`);
        }
    },
    onInput: {
        on() {
            const { dateMask } = this.config.getMasks();
            const { type } = this.config.get();

            // Отслеживаем ввод в инпут календаря
            this.input.$element.on(`input.${ this.instanceId }`, (e) => {
                const inputValue = this.input.dateMask({
                    event: e
                });

                const needPresentView = (type === 'date') && inputValue.length === dateMask.mask.length;

                if (needPresentView) {
                    this.dispatch('presentView');
                }
            });

            // Парсим значение на change событии, которое может прилететь снаружи календаря (сброс формы например)
            this.input.$element.on(`change.${ this.instanceId }`, () => {
                this.input.parse();
            });
        },

        off() {
            this.input.$element.off(`input.${ this.instanceId } change.${ this.instanceId }`);
        }
    },
    scrollOnCalendarList: {
        on() {
            const { $sheet } = this.sheet;
            const { mobile } = this.main;

            const sifter = 50;

            let lastAddYearTime;
            let scrollEndTmt;

            // NOTE: Все это безумие ниже только ради сафари
            let touched = false; // флаг сообщающий что юзер держит палец на экране
            let scrolled = false; // флаг сообщающий что скрол еще происходит

            // Проверяет нужно ли добавить год сверху или снизу и добавляет если нужно
            const addYearWorker = (force) => {
                const now = Date.now();
                const timePassed = force || lastAddYearTime == null || (now - lastAddYearTime) > sifter;

                if (!timePassed) {
                    return;
                }

                const needAddYear = this.sheet.checkNeedAddYear();

                if (needAddYear.need) {
                    // Добавляем год не чаще чем раз в ${ sifter }
                    needAddYear.directions.forEach((direction) => {
                        this.dispatch('addYear', { direction });
                    });

                    lastAddYearTime = now;
                }
            };

            $sheet.on(`scroll.${ this.instanceId }`, () => {
                scrolled = true;

                // На десктопе можем позволить загружать года динамически
                if (!mobile) {
                    addYearWorker();
                }

                // Scrollend
                clearTimeout(scrollEndTmt);
                scrollEndTmt = setTimeout(() => {
                    scrolled = false;

                    // По окончанию скрола проверяем еще раз не нужно ли чего пофиксить
                    if (!touched) {
                        addYearWorker(true);
                    }
                }, 150);
            });

            // Сафари на iOS буквально сходит с ума если начать менять позицию скрола или контейнер пока зажат палец
            $sheet.on(`touchstart.${ this.instanceId }`, (e) => {
                touched = !!e.touches.length;
            });

            // Отпустили палец - проверяем нужно ли что то догрузить, но только если не скролится в текущий момент
            $sheet.on(`touchend.${ this.instanceId }`, (e) => {
                touched = !!e.touches.length;

                // Не скролится в данный момент - проверяем не добавить ли годков
                if (!scrolled) {
                    addYearWorker(true);
                }
            });
        },

        off() {
            const { $sheet } = this.sheet;

            $sheet.off(`scroll.${ this.instanceId } touchstart.${ this.instanceId } touchend.${ this.instanceId }`);
        }
    },
    clickOnDay: {
        on() {
            // Отслеживаем клик по дню календаря
            this.sheet.$sheet.on(`click.${ this.instanceId }`, '.f-calendar__sheet--day', (e) => {
                e.preventDefault();
                const $day = $(e.target).closest('.f-calendar__sheet--day');

                // Не обрабатываем клик по заглушке
                if ($day.hasClass('f-calendar__sheet--day_stub')) {
                    return;
                }

                this.dispatch('selectDateByClick', {
                    date: Number($day.attr('date')),
                    month: Number($day.attr('month')),
                    year: Number($day.attr('year')),
                    disabled: $day.hasClass('f-calendar__sheet--day_disabled')
                });
            });
        },
        off() {
            this.sheet.$sheet.off(`click.${ this.instanceId }`);
        }
    },

    clickOutCalendar: {
        on() {
            $(document).on(`click.${ this.instanceId }`, (e) => {
                const $target = $(e.target);

                // Если клик был не по календарю, не по инпуту и не по его дочерним элементам
                const closeClick = (
                    !$target.closest(this.main.$calendar).length &&
                    !$target.closest(this.input.$icon).length &&
                    !$target.is(this.input.$element) &&
                    !$target.is($('body')) &&
                    !$target.is(this.input.$overlay)
                );

                if (closeClick) {
                    this.dispatch('hideCalendar');
                }
            });

            $(document).on('focus.calendar', 'input, .f-calendar__input-overlay', (e) => {
                const targetId = $(e.currentTarget).attr('element-id');

                if (targetId !== this.instanceId) {
                    this.dispatch('hideCalendar');
                }
            });
        },
        off() {
            $(document).off(`click.${ this.instanceId }`);
            $(document).off('focus.calendar', 'input, .f-calendar__input-overlay');
        }
    },

    clickOnOverlay: {
        on() {
            this.input.$overlay.on(`click.${ this.instanceId }`, () => {
                this.dispatch('showCalendar');
            });
        },
        off() {
            this.input.$overlay.off(`click.${ this.instanceId }`);
        }
    },

    // Фокус в инпут с календарем
    focusOnInput: {
        on() {
            this.input.$element.on(`focus.${ this.instanceId }`, () => {
                const { showed } = this.main;

                if (!showed) {
                    this.dispatch('showCalendar');
                }
            });
        },
        off() {
            this.input.$element.off(`focus.${ this.instanceId }`);
        }
    },

    swipeController: {
        on() {
            const swipe = {
                start: 0,
                current: 0,
                distance: 0
            };

            this.main.$holder.on(`touchstart.${ this.instanceId }`, (e) => {
                swipe.start = e.touches[0].screenY;
                swipe.distance = 0;

                this.main.$calendar.addClass('f-calendar_swipe');
            });

            this.main.$holder.on(`touchmove.${ this.instanceId }`, (e) => {
                swipe.current = e.touches[0].screenY;
                swipe.distance = swipe.current - swipe.start;
                swipe.progress = swipe.distance / (window.innerHeight - 150);

                if (swipe.distance < 0) {
                    return;
                }

                this.main.$container.css('transform', `translateY(${ swipe.distance }px)`);
                this.main.$overlay.css('opacity', Math.max(0, 1 - swipe.progress));
            });

            this.main.$holder.on(`touchend.${ this.instanceId }`, () => {
                this.main.$calendar.removeClass('f-calendar_swipe');
                this.main.$container.removeAttr('style');
                this.main.$overlay.removeAttr('style');

                const limit = $(window).height() / 6;

                if (swipe.distance > limit || swipe.distance === 0) {
                    this.dispatch('hideCalendar');
                }
            });
        },
        off() {
            this.main.$holder.off(`touchstart.${ this.instanceId }`);
            this.main.$holder.off(`touchmove.${ this.instanceId }`);
            this.main.$holder.off(`touchend.${ this.instanceId }`);
        }
    },
    clickOnTimeSelectorCloseBtn: {
        on() {
            if (!this.timeSelector) {
                return false;
            }

            this.timeSelector.$time_selector_close_btn.on(`click.${ this.instanceId }`, () => {
                this.dispatch('hideTimeSelector');
            });
        },
        off() {
            if (!this.timeSelector) {
                return false;
            }

            this.timeSelector.$time_selector_close_btn.off(`click.${ this.instanceId }`);
        }
    },
    clickOnTimeSelectorItem: {
        on() {
            if (!this.timeSelector) {
                return false;
            }

            // Отслеживаем клик по времени
            this.timeSelector.$time_selector.on(`click.${ this.instanceId }`, '.f-calendar__time-selector--item', (e) => {
                const $time = $(e.target);
                const stub = $time.hasClass('f-calendar__time-selector--item_stub');

                if (stub) {
                    return;
                }

                this.dispatch('selectTimeByClick', {
                    hour: Number($time.attr('hour')),
                    minute: Number($time.attr('minute'))
                });
            });
        },
        off() {
            if (!this.timeSelector) {
                return false;
            }

            this.timeSelector.$time_selector.off(`click.${ this.instanceId }`);
        }
    },
    clickOnDateSelectorTrigger: {
        on() {
            if (!this.dateSelector) {
                return false;
            }

            // Отслеживаем клик тригеру селектора даты
            this.dateSelector.$date_selector_trigger.on(`click.${ this.instanceId }`, () => {
                if (this.dateSelector.showed) {
                    this.dispatch('hideDateSelector');
                }
                else {
                    this.dispatch('showDateSelector');
                }
            });
        },
        off() {
            if (!this.dateSelector) {
                return false;
            }

            this.dateSelector.$date_selector_trigger.off(`click.${ this.instanceId }`);
        }
    },
    clickOnDateSelectorCloseBtn: {
        on() {
            if (!this.dateSelector) {
                return false;
            }

            this.dateSelector.$date_selector_close_btn.on(`click.${ this.instanceId }`, () => {
                const { showed } = this.dateSelector;
                if (showed) {
                    this.dispatch('hideDateSelector');
                }
                else {
                    this.dispatch('hideCalendar');
                }
            });
        },
        off() {
            if (!this.dateSelector) {
                return false;
            }

            this.dateSelector.$date_selector_close_btn.off(`click.${ this.instanceId }`);
        }
    },
    clickOutDateSelector: {
        on() {
            if (!this.dateSelector) {
                return false;
            }

            $(document).on(`click.${ this.instanceId }`, (e) => {
                // Если клик был не по календарю, не по инпуту и не по его дочерним элементам
                const closeClick = (
                    !this.dateSelector.$date_selector_container.is(e.target) &&
                    this.dateSelector.$date_selector_container.has(e.target).length === 0
                );

                if (closeClick) {
                    this.dispatch('hideDateSelector');
                }
            });
        },
        off() {
            if (!this.dateSelector) {
                return false;
            }

            $(document).off(`click.${ this.instanceId }`);
        }
    },
    clickOnDateSelector: {
        on() {
            if (!this.dateSelector) {
                return false;
            }

            const getCurrentMonth = () => {
                const $currentMonth = this.dateSelector.$date_selector_month_list.find('.f-calendar__date-selector--month-item_active');
                return Number($currentMonth.attr('month'));
            };

            const getCurrentYear = () => {
                const $currentYear = this.dateSelector.$date_selector_year_list.find('.f-calendar__date-selector--year-item_active');
                return Number($currentYear.attr('year'));
            };

            this.dateSelector.$date_selector_month_list.on(`click.${ this.instanceId }`, '.f-calendar__date-selector--month-item', (e) => {
                const $selectedMonth = $(e.target);

                if ($selectedMonth.hasClass('f-calendar__date-selector--month-item_disabled')) {
                    return;
                }

                const month = Number($selectedMonth.attr('month'));
                const year = getCurrentYear();

                this.dispatch('selectByDateSelector', { month, year, direction: 'month' });
            });

            this.dateSelector.$date_selector_year_list.on(`click.${ this.instanceId }`, '.f-calendar__date-selector--year-item', (e) => {
                const $selectedYear = $(e.target);

                const year = Number($selectedYear.attr('year'));
                const month = getCurrentMonth();


                this.dispatch('selectByDateSelector', { month, year, direction: 'year' });
            });
        },
        off() {
            if (!this.dateSelector) {
                return false;
            }

            this.dateSelector.$date_selector_month_list.off(`click.${ this.instanceId }`);
            this.dateSelector.$date_selector_year_list.off(`click.${ this.instanceId }`);
        }
    }
};

class Relay {
    constructor(root) {
        this.root = root;

        this.listeners = [];
    }

    getListeners() {
        return this.listeners;
    }
    addListener(listener) {
        this.listeners.push(listener);
    }
    removeListener(listener) {
        const index = this.listeners.indexOf(listener, 0);

        if (index >= 0) {
            this.listeners.splice(index, 1);
        }
    }
    includesListener(listener) {
        return this.listeners.includes(listener, 0);
    }

    on(listener) {
        if (!listeners[listener]) {
            console.warn(`on(${ listener }) - Unknown listener`);
            return false;
        }

        const includedListener = this.includesListener(listener);

        if (includedListener) {
            return true;
        }

        this.addListener(listener);

        listeners[listener].on.call(this.root);
    }

    off(listener) {
        // Проверяем существует ли нужный слушатель
        if (!listeners[listener]) {
            console.warn(`off(${ listener }) - Unknown listener`);
            return false;
        }

        // Проверяем есть ли слушатель в списке включенных слушателей
        const includedListener = this.includesListener(listener);

        if (!includedListener) {
            return true;
        }

        // Удаляем из списка
        this.removeListener(listener);

        // Выключаем слушателя
        listeners[listener].off.call(this.root);
    }

    // offAll() {
    //     /* eslint no-loops/no-loops: 0 */
    //     for (const listener in listeners) {
    //         if (listeners[listener]) {
    //             listeners[listener].off();
    //         }
    //     }
    // }
}

export default Relay;
